import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, resolveComponent as _resolveComponent } from "vue"

import {ref, onMounted, onUpdated} from "vue";
import {
  IonCard,
  IonCardHeader,
  IonCardTitle,
  IonCardContent,
  IonList,
  IonItem,
  IonLabel,
  IonInput,
  IonIcon,
  IonSelect, IonSelectOption,
  IonButton, IonButtons,
  IonGrid, IonRow, IonCol,
  toastController, onIonViewDidEnter
} from "@ionic/vue";
import {UserTrackingTemplate} from "@/mobipoints/profile/userTrackingTemplate/user_tracking_template.type";
import {MobiPointApiProfile} from "@/mobipoints/api/profile";
import router from "@/router";
import * as icons from 'ionicons/icons';
import {AxiosError, AxiosResponse} from "axios";
import useProfileFactory from "@/composable/useProfileFactory";
import useMainData from "@/composable/useMainData";


export default /*#__PURE__*/_defineComponent({
  __name: 'UserTrackingTemplateEdit',
  props: {
  userTrackingTemplateId: {
    type: Number,
    required: false,
  }
},
  setup(__props, { expose: __expose }) {

const props = __props;

const { getProfileFactory } = useProfileFactory();

const userTrackingTemplate = ref<UserTrackingTemplate>(getProfileFactory().createEmptyUserTrackingTemplate());
const title = ref<string>('');
const mainData = useMainData();

onMounted(() => {
  if (props.userTrackingTemplateId) {
    loadUserTrackingTemplate(props.userTrackingTemplateId);
    title.value = 'Tracking Vorlage bearbeiten';
  } else {
    userTrackingTemplate.value = getProfileFactory().createEmptyUserTrackingTemplate();
    title.value = 'Tracking Vorlage hinzufügen';
  }
});

const loadUserTrackingTemplate = async function (id: number) {
  try {
    const response = await MobiPointApiProfile.getUserTrackingTemplate(id);
    userTrackingTemplate.value = getProfileFactory().createUserTrackingTemplateListByApiResponse(response.data).shift() ?? userTrackingTemplate.value;
  } catch (error: any | AxiosError) {
    // TODO create a custom toast controller to handle this kind of toasts (display error and go back)
    const toast = await toastController.create({
      message: `Could not load user tracking template ${id}`,
      position: 'bottom',
      duration: 3000,
      icon: icons.warning,
      buttons: [
        {
          side: 'end',
          role: 'cancel',
          icon: icons.close
        }
      ]
    });
    toast.onWillDismiss().then(router.back);
    return toast.present();
  }
}

const validateUserTrackingTemplate = async function (): Promise<boolean> {
  let message: string | null = null;

  if (userTrackingTemplate.value.name.length < 1) {
    message = 'Please enter a name for the tracking template!';
  } else if (!userTrackingTemplate.value.userTrackingTrackType || !userTrackingTemplate.value.userTrackingTrackType.code) {
    message = 'Please define a track type for the tracking template!';
  }

  if (null !== message) {
    const toast = await toastController.create({
      message: message,
      position: 'bottom',
      duration: 3000,
      icon: icons.warning,
      buttons: [
        {
          side: 'end',
          role: 'cancel',
          icon: icons.close
        }
      ]
    });

    await toast.present();

    return false;
  }

  return true;
}

const saveUserTrackingTemplate = async function (): Promise<AxiosResponse<string> | null> {
  let message = `User tracking successfully saved!`;
  let icon = icons.checkmarkCircleOutline;
  let duration = 2000;
  let response: AxiosResponse | null = null;
  try {
    if (null === userTrackingTemplate.value.id) {
      response = await MobiPointApiProfile.createUserTrackingTemplate(userTrackingTemplate.value);
    } else {
      response = await MobiPointApiProfile.updateUserTrackingTemplate(userTrackingTemplate.value);
    }
  } catch (error: any | AxiosError) {
    message = `Could not save user tracking template ${userTrackingTemplate.value.id}`;
    icon = icons.warning;
    duration = 3000;
  }

  const toast = await toastController.create({
    message: message,
    position: 'bottom',
    duration: duration,
    icon: icon,
    buttons: [
      {
        side: 'end',
        role: 'cancel',
        icon: icons.close
      }
    ]
  });
  await toast.present();

  return response;
}

const openAddLocation = () => {
  router.push({
    name: 'UserLocationAdd',
  });
};

__expose({
  validateUserTrackingTemplate,
  saveUserTrackingTemplate
});

return (_ctx: any,_cache: any) => {
  const _component_ion_ripple_effect = _resolveComponent("ion-ripple-effect")!

  return (_openBlock(), _createBlock(_unref(IonCard), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonCardHeader), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonCardTitle), null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(title.value), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(IonCardContent), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonList), {
            class: "ion-no-margin",
            lines: "full"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonItem), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonLabel), { position: "stacked" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Name")
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(IonInput), {
                    modelValue: userTrackingTemplate.value.name,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((userTrackingTemplate.value.name) = $event)),
                    placeholder: "Name"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_unref(IonItem), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonLabel), { position: "stacked" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Typ")
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(IonSelect), {
                    modelValue: userTrackingTemplate.value.userTrackingTrackType.code,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((userTrackingTemplate.value.userTrackingTrackType.code) = $event)),
                    interface: "popover"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(mainData).userTrackingTrackTypes.value, (userTrackingTrackType) => {
                        return (_openBlock(), _createBlock(_unref(IonSelectOption), {
                          key: userTrackingTrackType.code,
                          value: userTrackingTrackType.code
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(userTrackingTrackType.name), 1)
                          ]),
                          _: 2
                        }, 1032, ["value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_unref(IonItem), { lines: "none" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonLabel), { position: "stacked" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Startpunkt")
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(IonSelect), {
                    modelValue: userTrackingTemplate.value.startLocation.id,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((userTrackingTemplate.value.startLocation.id) = $event)),
                    interface: "popover"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonSelectOption), { value: null }, {
                        default: _withCtx(() => [
                          _createTextVNode("- kein Startpunkt -")
                        ]),
                        _: 1
                      }),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(mainData).userLocations.value, (location) => {
                        return (_openBlock(), _createBlock(_unref(IonSelectOption), {
                          key: location.id,
                          value: location.id
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(location.getFormattedAddress()), 1)
                          ]),
                          _: 2
                        }, 1032, ["value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_unref(IonItem), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonButtons), { slot: "end" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonButton), {
                        onClick: openAddLocation,
                        color: "primary"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonIcon), {
                            icon: icons.add
                          }, null, 8, ["icon"]),
                          _createVNode(_unref(IonLabel), { style: {"margin-left":".5rem"} }, {
                            default: _withCtx(() => [
                              _createTextVNode("Standort hinzufügen")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_ripple_effect)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_unref(IonItem), { lines: "none" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonLabel), { position: "stacked" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Endpunkt")
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(IonSelect), {
                    modelValue: userTrackingTemplate.value.endLocation.id,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((userTrackingTemplate.value.endLocation.id) = $event)),
                    interface: "popover"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonSelectOption), { value: null }, {
                        default: _withCtx(() => [
                          _createTextVNode("- kein Endpunkt -")
                        ]),
                        _: 1
                      }),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(mainData).userLocations.value, (location) => {
                        return (_openBlock(), _createBlock(_unref(IonSelectOption), {
                          key: location.id,
                          value: location.id
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(location.getFormattedAddress()), 1)
                          ]),
                          _: 2
                        }, 1032, ["value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_unref(IonItem), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonButtons), { slot: "end" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonButton), {
                        onClick: openAddLocation,
                        color: "primary"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonIcon), {
                            icon: icons.add
                          }, null, 8, ["icon"]),
                          _createVNode(_unref(IonLabel), { style: {"margin-left":".5rem"} }, {
                            default: _withCtx(() => [
                              _createTextVNode("Standort hinzufügen")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_ripple_effect)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})